let phases= [
  {top: "70%", left: "20%", avatar: "54%" },
  {top: "60%", left: "28%", avatar: "44%" },
  {top: "61%", left: "36%", avatar: "45%" },
  {top: "80%", left: "35%", avatar: "64%" },
  {top: "80%", left: "46%", avatar: "54%" },
  {top: "70%", left: "46%", avatar: "54%" },
  {top: "60%", left: "44%", avatar: "44%" },
  {top: "60%", left: "52%", avatar: "44%" },
  {top: "70%", left: "54%", avatar: "54%" },
  {top: "80%", left: "54%", avatar: "64%" },
   {top: "80%", left: "67%", avatar: "64%" },
   {top: "68%", left: "65%", avatar: "52%" },
   {top: "78%", left: "80%", avatar: "62%" },
   {top: "58%", left: "70%", avatar: "42%" },
   {top: "56%", left: "58%", avatar: "40%" }];

   export default phases;